module.exports = __webpack_public_path__ + "img/play-callout.9288960e.png";